<template>
  <footer class="upload-footer">
    <div class="upload-footer__content">
      Copyright © 2022 Spring Financial. All rights reserved.
      Spring Financial® and the Spring Financial Logo design are
      registered trademarks of Spring Financial Ltd. Other
      trademarks are the property of their respective owners.
    </div>
  </footer>
</template>

<script>
/**
 * <component></component>
 * @desc description
 */
export default {
  // Name
  name: 'the-footer',

  // Components
  components: {},

  // Props
  props: {},

  // Mixins
  mixins: [],

  // Data
  data () {
    return {
      msg: 'Hello World'
    }
  },

  // Computed
  computed: {},

  // Watch
  watch: {},

  // Methods
  methods: {},

  // Created
  created () {},

  // Mounted
  mounted () {}
}
</script>

<style scoped lang="scss">
.upload-footer {
  display: flex;
  // padding: 20px;
  // box-shadow: none;
  border-top: 2px solid #d8d8d8;
  font-size: 8px;
  background-color: #fff;

  &__content {
    margin: auto;
    max-width: 500px;
    padding: 20px;
  }
}
</style>
